import { useEffect, useState } from "react";

const useFonts = () => {
  const [fontsIsLoaded, setFontsIsLoaded] = useState(false);

  useEffect(() => {
    document.fonts.ready.then((res) => {
      if (res.status === "loaded") {
        setFontsIsLoaded(true);
      }
    });
  }, []);

  return {
    fontsIsLoaded,
  };
};

export { useFonts };
